import styled from "styled-components";

export const UploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom:20px;
`;

export const UploadButton = styled.div`
  display: flex;
  margin-top: 1rem;
  border: 1px solid #E4E4E4;
  box-shadow: 0px 0px 6px rgba(74, 74, 74, 0.19);
  border-radius: 10px;
  padding: 48px;
  justify-content: center;
  cursor: pointer;
  position: relative;
  & > input {
    display: none;
  }
`;

export const Error = styled.p`
  color: red;
  font-size: 1.2rem;
  /* bottom: ${props => props.bottom ? props.bottom : '-1.4rem'}; */
  /* z-index: 9; */
  margin-left: 0.2rem;
  margin-top:12px;
  /* position: absolute; */
`;

export const DownloadButton = styled.div`
    display: flex;
    justify-content: center;
    align-items:center;
    border-radius: 10px;
    background-color:  ${props => props.theme.accentColor};
    /* margin-top: 24px; */
    padding: 20px;
    cursor: pointer;
    max-width: 40%;
    height: 36px;
`